// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIncludeToBalanceReminderPropertyDto
 */
export interface IIncludeToBalanceReminderPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIncludeToBalanceReminderPropertyDto
     */
    include_to_balance_reminder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIncludeToBalanceReminderPropertyDto
     */
    include_to_balance_reminder_state?: IIncludeToBalanceReminderPropertyDtoIncludeToBalanceReminderStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIncludeToBalanceReminderPropertyDtoIncludeToBalanceReminderStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIncludeToBalanceReminderPropertyDto interface.
 */
export function instanceOfIIncludeToBalanceReminderPropertyDto(value: object): value is IIncludeToBalanceReminderPropertyDto {
    return true;
}

export function IIncludeToBalanceReminderPropertyDtoFromJSON(json: any): IIncludeToBalanceReminderPropertyDto {
    return IIncludeToBalanceReminderPropertyDtoFromJSONTyped(json, false);
}

export function IIncludeToBalanceReminderPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIncludeToBalanceReminderPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'include_to_balance_reminder': json['include_to_balance_reminder'] == null ? undefined : json['include_to_balance_reminder'],
        'include_to_balance_reminder_state': json['include_to_balance_reminder_state'] == null ? undefined : json['include_to_balance_reminder_state'],
    };
}

export function IIncludeToBalanceReminderPropertyDtoToJSON(json: any): IIncludeToBalanceReminderPropertyDto {
    return IIncludeToBalanceReminderPropertyDtoToJSONTyped(json, false);
}

export function IIncludeToBalanceReminderPropertyDtoToJSONTyped(value?: IIncludeToBalanceReminderPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'include_to_balance_reminder': value['include_to_balance_reminder'],
        'include_to_balance_reminder_state': value['include_to_balance_reminder_state'],
    };
}

